import Table from "../../../../Components/Table";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import { BuscarInformacoesEnvelopeController } from "../../../../Controllers/Geral/Email/EmailController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import moment from "moment";
import { ColumnDescription } from "react-bootstrap-table-next";

interface VisualizarEnvelopeProps {
    id_envelope: number;
    setShow: (show: boolean) => void;
}

export default function VisualizarEnvelope({
    id_envelope,
    setShow,
}: VisualizarEnvelopeProps) {
    const { value: informacoesEnvelope, loading: informacoesEnvelopeLoading } =
        useAsyncEffect(async () => {
            if (id_envelope) {
                return BuscarInformacoesEnvelopeController(id_envelope);
            }
        }, [id_envelope]);

    const documentosColumns: ColumnDescription[] = [
        {
            dataField: "NR_ORDEM",
            text: "Ordem",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DS_DOCUMENTO",
            text: "Documento",
            align: "center",
            headerAlign: "center",
        },
    ];

    const usuariosColumns: ColumnDescription[] = [
        {
            dataField: "NR_ORDEM",
            text: "Ordem",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DS_NOME",
            text: "Nome",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DS_CARGO",
            text: "Cargo",
            align: "center",
            headerAlign: "center",
            formatter: (cell) => cell || "-",
        },
        {
            dataField: "DS_STATUS",
            text: "Status",
            align: "center",
            headerAlign: "center",
            formatter: (cell) => (
                <span className={`badge bg-${getStatusColor(cell)}`}>
                    {cell}
                </span>
            ),
        },
        {
            dataField: "DT_STATUS",
            text: "Data Status",
            align: "center",
            headerAlign: "center",
            formatter: (cell) => moment(cell).format("DD/MM/YYYY HH:mm"),
        },
        {
            dataField: "DT_ENVIO",
            text: "Data Envio",
            align: "center",
            headerAlign: "center",
            formatter: (cell) =>
                cell ? moment(cell).format("DD/MM/YYYY HH:mm") : "-",
        },
        {
            dataField: "DT_ENTREGA",
            text: "Data Entrega",
            align: "center",
            headerAlign: "center",
            formatter: (cell) =>
                cell ? moment(cell).format("DD/MM/YYYY HH:mm") : "-",
        },
        {
            dataField: "DT_ASSINATURA",
            text: "Data Assinatura",
            align: "center",
            headerAlign: "center",
            formatter: (cell) =>
                cell ? moment(cell).format("DD/MM/YYYY HH:mm") : "-",
        },
    ];

    const columnsInformacoesGerais: ColumnDescription[] = [
        {
            dataField: "DS_STATUS",
            text: "Status",
            align: "center",
            headerAlign: "center",
            formatter: (cell) => (
                <span className={`badge bg-${getStatusColor(cell)}`}>
                    {cell}
                </span>
            ),
        },
        {
            dataField: "DT_CADASTRO",
            text: "Data de Cadastro",
            formatter: (cell) => moment(cell).format("DD/MM/YYYY HH:mm"),
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DT_ENVIO",
            text: "Data de Envio",
            formatter: (cell) =>
                cell ? moment(cell).format("DD/MM/YYYY HH:mm") : "-",
            align: "center",
            headerAlign: "center",
        },
    ];

    const getStatusColor = (status: string) => {
        switch (status?.toLowerCase()) {
            case "enviado":
                return "info";
            case "entregue":
                return "primary";
            case "assinado":
                return "success";
            case "pendente":
                return "warning";
            default:
                return "secondary";
        }
    };

    return (
        <OrSpinner loading={informacoesEnvelopeLoading} spinner="capys">
            <div className="container py-4">
                <div className="card shadow-sm mb-4">
                    <div className="card-header bg-light">
                        <h5 className="mb-0">Informações Gerais</h5>
                    </div>
                    <div className="card-body">
                        <Table
                            keyField="DS_STATUS"
                            data={[informacoesEnvelope]}
                            columns={columnsInformacoesGerais}
                            noSearch
                            noDataIndication={() => (
                                <div className="text-center text-muted">
                                    Nenhuma informação encontrada
                                </div>
                            )}
                            sizePerPage={5}
                        />
                    </div>
                </div>

                <div className="card shadow-sm mb-4">
                    <div className="card-header bg-light">
                        <h5 className="mb-0">Documentos</h5>
                    </div>
                    <div className="card-body">
                        <Table
                            keyField="ID_DOCUMENTO"
                            data={informacoesEnvelope?.DOCUMENTOS ?? []}
                            columns={documentosColumns}
                            noSearch
                            noDataIndication={() => (
                                <div className="text-center text-muted">
                                    Nenhum documento encontrado
                                </div>
                            )}
                            sizePerPage={5}
                        />
                    </div>
                </div>

                <div className="card shadow-sm mb-4">
                    <div className="card-header bg-light">
                        <h5 className="mb-0">Destinatários</h5>
                    </div>
                    <div className="card-body">
                        <Table
                            keyField="ID_CONTA"
                            data={informacoesEnvelope?.USUARIOS ?? []}
                            columns={usuariosColumns}
                            noSearch
                            noDataIndication={() => (
                                <div className="text-center text-muted">
                                    Nenhum destinatário encontrado
                                </div>
                            )}
                            sizePerPage={5}
                        />
                    </div>
                </div>

                {informacoesEnvelope?.DS_MENSSAGEM_LOG && (
                    <div className="card shadow-sm mb-4">
                        <div className="card-header bg-light">
                            <h5 className="mb-0">Log</h5>
                        </div>
                        <div className="card-body">
                            <div className="alert alert-info mb-0">
                                {informacoesEnvelope?.DS_MENSSAGEM_LOG}
                            </div>
                        </div>
                    </div>
                )}

                <div className="d-flex justify-content-end">
                    <button
                        className="btn btn-danger px-4"
                        onClick={() => setShow(false)}
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </OrSpinner>
    );
}
